import { DataGrid } from "@mui/x-data-grid";
import { createTheme, ThemeProvider } from "@mui/material/styles";
import { Button, Box } from "@mui/material";
import IosShareIcon from "@mui/icons-material/IosShare";
import { exportToExcel } from "../Utils/ExportToExcel";
import { hebrewGridLocale } from "../Utils/hebrewGridLocale";

export const DataGridTable = ({
  columns,
  rows,
  getRowId,
  checkboxSelection,
  handleCheckboxChange,
  isCheckboxVisible,
  handleRowClick,
}) => {
  const handleExport = () => {
    exportToExcel(rows, columns, "FinancialData");
  };

  const theme = createTheme({
    direction: "rtl",
    components: {
      MuiDataGrid: {
        styleOverrides: {
          root: {
            "& .MuiDataGrid-footerContainer": {
              borderTop: "1px solid GREY",
            },
            "& .MuiTablePagination-selectLabel, & .MuiTablePagination-displayedRows":
            {
              margin: "0 10px",
            },
            "& .MuiTablePagination-actions": {
              marginLeft: "20px",
            },
            "& .MuiIconButton-root.Mui-disabled": {
              opacity: 0.5,
            },
            "& .MuiDataGrid-row:nth-of-type(odd)": {
              backgroundColor: "#f5f5f5",
            },
            "& .MuiDataGrid-row:nth-of-type(even)": {
              backgroundColor: "#ffffff",
            },
            "& .MuiDataGrid-row:hover": {
              backgroundColor: "#ebf7ff",
            },
            "& .MuiDataGrid-columnHeaders": {
              backgroundColor: "#f8fafc", // רקע בהיר לשורת הכותרות
              borderBottom: "1px solid #e2e8f0", // קו הפרדה עדין
            },
            "& .MuiDataGrid-columnHeader": {
              padding: "16px", // מרווח פנימי
            },
            "& .MuiDataGrid-columnHeaderTitle": {
              fontWeight: "600", // עובי גופן
              fontSize: "0.875rem", // גודל גופן
              color: "#1e293b", // צבע טקסט כהה
            },
          },
        },
      },
    },
  });

  return (
    <ThemeProvider theme={theme}>
      <div dir="rtl" style={{ width: "100%", overflowX: "auto" }}>
        <Box display="flex" justifyContent="flex-end" mb={2}>
          <Button
            variant="contained"
            style={{
              backgroundColor: "#217346",
            }}
            onClick={handleExport}
            startIcon={<IosShareIcon />}
          >
            ייצוא לאקסל
          </Button>
        </Box>
        <DataGrid
          rows={rows}
          columns={columns.map((column) => ({
            ...column,
            minWidth: 150,
            flex: 1,
          }))}
          initialState={{
            pagination: {
              paginationModel: {
                pageSize: 10,
              },
            },
          }}
          pageSizeOptions={[10, 25, 50]}
          checkboxSelection={checkboxSelection}
          onRowSelectionModelChange={
            checkboxSelection
              ? (newSelection) => handleCheckboxChange(newSelection)
              : undefined
          }
          isRowSelectable={isCheckboxVisible}
          disableRowSelectionOnClick={true}
          getRowId={getRowId}
          onRowClick={handleRowClick}
          autoHeight
          autoWidth
          localeText={hebrewGridLocale.localeText}
          sx={{
            '& .MuiDataGrid-cell:focus': {
              outline: 'none',
            },
            '& .MuiDataGrid-row:last-child': {
              borderBottom: 'none',
            },
          }}
          style={{ width: "100%", marginTop: "8px" }}
        />
      </div>
    </ThemeProvider>
  );
};
